exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".card-under[data-v-503b6714]{font-size:20px}.purchases[data-v-503b6714]{padding-bottom:2rem}", ""]);
